import React from 'react';
import styled from '@emotion/styled';
import { Link } from 'react-router-dom';

import { Text } from '../text';
import { color } from '../theme';

export const AppLink = styled(Link)`
  text-decoration: underline;
  text-decoration-color: ${props =>
    props['aria-disabled'] ? 'none' : color('yellowMedium')};
  text-decoration-thickness: 4px;

  background-size: 100% 200%;
  background-image: linear-gradient(
    to top,
    ${color('yellowMedium')} 50%,
    white 50%
  );
  -webkit-transition: background-position 0.3s;
  -moz-transition: background-position 0.3s;
  transition: background-position 0.3s;

  pointer-events: ${props => (props['aria-disabled'] ? 'none' : 'auto')};

  :hover {
    background-color: ${color('yellowMedium')};
    background-position: ${props =>
      props['aria-disabled'] ? '0 0' : '0 100%'};
  }
`;

interface AnchorProps extends React.HTMLProps<HTMLAnchorElement> {}

export const ExternalLink = styled(Text)<AnchorProps>`
  text-decoration: underline;
  text-decoration-color: ${color('yellowMedium')};
  text-decoration-thickness: 4px;

  cursor: pointer;

  background-size: 100% 200%;
  background-image: linear-gradient(
    to top,
    ${color('yellowMedium')} 50%,
    white 50%
  );
  -webkit-transition: background-position 0.3s;
  -moz-transition: background-position 0.3s;
  transition: background-position 0.3s;

  :hover {
    background-color: ${color('yellowMedium')};
    background-position: 0 100%;
  }
`;

ExternalLink.defaultProps = {
  as: 'a',
  rel: 'noreferrer',
  target: '_blank',
};

export const ExternalImageLink = styled.image<AnchorProps>`
  cursor: pointer;
  clip-path: circle(28px);
  background-color: transparent;
`;

ExternalImageLink.defaultProps = {
  as: 'a',
  rel: 'noopener',
};

export const GreenLink = styled(Text)<AnchorProps>`
  color: #026572;
  text-decoration: none;
  cursor: pointer;
`;

GreenLink.defaultProps = {
  variant: 'text4',
  as: 'a',
};
